import { getApps, initializeApp } from '@firebase/app'
import config from '../../firebase.config'

const app = getApps()[0] || initializeApp(config)
export default app
